import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";
import { HRM2040_R01Content } from "./Content_HRM2040_R01";
import { HRM2040_R01Dto } from "./Dto_HRM2040_R01";
import { HRM2040_R01SearchSection } from "./SearchSection_HRM2040_R01";
import { Table_HRM2040_R01 } from "./Table_HRM2040_R01";

/**
 * 월근태 집계의 액션바·검색조건·편집 그리드·안내 메시지를 조립한다.
 * @returns 조회·저장·Excel·초기화·재집계가 연결된 화면
 */
export const Container_HRM2040_R01 = () => {
    // 편집 확정과 첫 행 이동에 사용하며 Content와 Table이 같은 그리드를 가리킨다.
    const gridRef = useRef<AgGridReact<HRM2040_R01Dto>>(null);
    // 조회·저장 결과를 화면 하단 메시지에 표시하는 함수를 가져온다.
    const { setMessage } = useUiuxStore();
    // 화면 동작과 행 클릭 상태를 Content에서 가져온다.
    const {
        clickable, setClickable, fetchData, initData,
        handleSaveClick, handleExcelClick, handleAggregateClick,
    } = HRM2040_R01Content({ gridRef, setMessage });

    return (
        // 화면 전체를 액션바·검색 영역·목록·메시지 순서로 배치한다.
        <div className="content-container">
            {/* 조회·저장·Excel·초기화를 실행하는 공통 액션바이다. */}
            <Actionbar
                onFetchClick={fetchData}
                onSaveClick={handleSaveClick}
                onExcelClick={handleExcelClick}
                onInitClick={initData}
            />
            {/* 근무년월·사업장·부서와 월근태 재집계 버튼이다. */}
            <HRM2040_R01SearchSection onAggregateClick={handleAggregateClick} />
            {/* 단일 월근태 그리드가 남은 화면 높이를 사용한다. */}
            <div className="flex-1 flex">
                {/* 기준 화면과 같은 안쪽 여백을 적용한다. */}
                <div className="w-full h-full flex flex-col p-[12px] gap-[12px]">
                    {/* 숫자와 비고를 편집하고 아래 고정 행에 건수·합계를 표시한다. */}
                    <Table_HRM2040_R01 clickable={clickable} setClickable={setClickable} gridRef={gridRef} />
                </div>
            </div>
            {/* 조회·저장 완료 문장을 표시하는 공통 하단 메시지이다. */}
            <Message />
        </div>
    );
};
